import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';

export const Content = styled('div')({
  width: '100%',
  padding: 20,
  color: colors.darkBrown,
  '& h3': {
    color: colors.caramel,
    fontFamily: fonts.title,
    fontSize: 16,
    lineHeight: '19px',
    fontWeight: 'bold',
  },
});

export const Level = styled('p')({
  margin: '12px 0 20px',
  fontSize: 14,
  fontWeight: 'bold',
  color: colors.caramel,
});

export const Video = styled('div')({
  position: 'relative',
  width: '100%',
  paddingTop: '56.25%',
  marginBottom: 20,
  '& iframe': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

export const SectionTitle = styled('h2')({
  margin: '28px 0 16px',
  fontFamily: fonts.title,
  fontSize: 22,
  color: colors.black,
});

export const Steps = styled('ol')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

export const Step = styled('li')({
  display: 'flex',
  gap: 14,
  marginBottom: 18,
  fontSize: 16,
  lineHeight: '22px',
});

export const StepNumber = styled('span')({
  flex: '0 0 auto',
  width: 28,
  height: 28,
  borderRadius: '50%',
  backgroundColor: colors.caramel,
  color: colors.white,
  fontFamily: fonts.title,
  fontWeight: 'bold',
  lineHeight: '28px',
  textAlign: 'center',
});

export const StepImage = styled('img')({
  display: 'block',
  width: '100%',
  marginTop: 10,
});

export const Print = styled('p')({
  margin: '8px 0 0',
  textAlign: 'center',
});
